import gql from 'graphql-tag'

export const queryComercialBaseByPk = baseId => {
	return {
		query: gql`
			query ($base_id: bigint!) {
				conf_comercial_base_by_pk(id: $base_id) {
					base
				}
			}
		`,
		update(data) {
			return data.conf_comercial_base_by_pk
		},
		variables: {
			base_id: baseId
		}
	}
}
